import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const SharePoint = () => {
  return (
    <StartInterviewLayout type="sharepoint"/>
  )
}

export default SharePoint;